import { recordTestInstance } from '../axios';

const getActiveInactiveVehicleNumbers = (vehNo: string, customerId: string, pagination = null, filters = { active: false }) =>
  recordTestInstance.post('/vehicle-numbers', { customerId, vehNo, pagination, filters });

export default getActiveInactiveVehicleNumbers;
